/** @format */

import { DotLoader } from 'halogenium';
import React, { Component } from 'react';

class Loading extends Component {
	render() {
		return (
			<div
				style={{
					width: '100%',
					textAlign: 'center',
					alignSelf: 'center',
					paddingTop: '1em',
					height: '100px',
					boxSizing: 'border-box',
					display: '-webkit-flex',
					WebkitFlex: '0 1 auto',
					flexDirection: 'row',
					WebkitAlignItems: 'center',
					alignItems: 'center',
					WebkitJustifyContent: 'center',
					justifyContent: 'center',
				}}
			>
				<DotLoader color='#008caa' size='64' />
			</div>
		);
	}
}

export default Loading;
